import React from 'react';
import { useTranslation } from 'react-i18next';
import LoginLayout from '../components/LoginLayout';
import LoginCard from '../components/LoginCard';
import Heading from '../../../generic-components/Heading';
import Button from '../../../generic-components/Button';
import { LOGIN_NAVIGATION_MAP } from '../components/LoginNavigation/constants';
import { useStore } from '../../../store';
import { TAKE_A_BREAK_SCREEN } from '../constants';

const TookABreak = () => {
  const setCurrentPage = useStore((state) => state.setCurrentPage);
  const { HEADER, TEXT, BUTTON } = TAKE_A_BREAK_SCREEN;

  const { t } = useTranslation();

  return (
    <LoginLayout backButton backDestination={LOGIN_NAVIGATION_MAP.VERIFICATION_CODE}>
      <LoginCard className='w-[50%] min-w-[24rem] left-[20%] top-[20%]' backgroundColor='bg-transparent'>
        <Heading title={t(HEADER)} className='w-[30rem] heading text-bw08 font-metricSemibold' />
        <Heading title={t(TEXT)} className='w-[30rem] text-base mt-2 mb-6 text-bw07 font-metric' />
        <Button
          id='TookABreak'
          onClick={() => setCurrentPage(LOGIN_NAVIGATION_MAP.WELCOME)}
          title={t(BUTTON)}
          className='w-40 font-metricBold leading-4 tracking-wide text-sm text-bw00 bg-action03 w-full h-12 rounded'
        />
      </LoginCard>
    </LoginLayout>
  );
};

export default TookABreak;
